import {domain, __a, __b, __e, __f} from './env'
export const getUrlQuery = (name) => {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
        return decodeURI(r[2])
    } else {
        return ''
    }
}
let isInMinPro = getUrlQuery('t') === 'sp'//小程序有身份
let isInMinProNoIndentify = getUrlQuery('t') === 'sp1'//小程序没有身份
function namesp (name) {
    if(isInMinPro||isInMinProNoIndentify){
        name= name+"_sp"
    }
    return name
}
export const readCookie = function (name) {
    name = namesp(name)
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = document.cookie.match(reg)
    if (arr) {
        return unescape(arr[2])
    } else {
        return ''
    }
}

export const createCookie = function (name, value, expires) {
    name = namesp(name)
    let exp = new Date()
    exp.setTime(exp.getTime() + Number(expires) * 1000)
    document.cookie = `${name}=${value};expires=${exp.toGMTString()};domain=${domain};path=/`
}

export const eraseCookie = function (name) {
    createCookie(name, '', -1)
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
    let target
    // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
    if (attr === 'scrollTop') {
        target = element.scrollTop
    } else if (element.currentStyle) {
        target = element.currentStyle[attr]
    } else {
        target = document.defaultView.getComputedStyle(element, null)[attr]
    }
    // 在获取 opactiy 时需要获取小数 parseFloat
    return NumberMode === 'float' ? parseFloat(target) : parseInt(target)
}

export const getHashUrlQuery = (name) => {
    // let reg = new RegExp('(^|&)' + name + '=([^&#]*)(&|#|$)', 'i'),
    //     url = window.location.href,
    //     r = url.substr(1).match(reg)
    // if (r != null) {
    //     return unescape(r[2])
    // } else {
    //     return ''
    // }
    return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||''
}



export const getDevice = () => {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i)) {
        return 'wx'
    } else if (/iphone|ipad|ipod/.test(ua)) {
        return 'ios'
    } else if (/android/.test(ua)) {
        return 'android'
    }
}

export const getAppDevice = () => {
    if (window.navigator.userAgent.indexOf('TeldIosWebView') !== -1) return 'Ios'
    else if (window.navigator.userAgent.indexOf('TeldAndroidWebView') !== -1) return 'Android'
    else return ''
}

export const checkMobile = function (mobile) {
    let strPhone = /^1[0-9]{10}$/
    if (mobile && mobile.length === 11 && strPhone.test(mobile)) {
        return true
    }
    return false
}

/**
 * 存储localStorage
 */
export const setLocalStore = (name, content) => {
    if (!name) return
    if (typeof content !== 'string') {
        content = JSON.stringify(content)
    }
    window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getLocalStore = name => {
    if (!name) return
    return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeLocalStore = name => {
    if (!name) return
    window.localStorage.removeItem(name)
}

/**
 * 存储sessionStorage
 */
export const setSessionStore = (name, content) => {
    if (!name) return
    if (typeof content !== 'string') {
        content = JSON.stringify(content)
    }
    window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSessionStore = name => {
    if (!name) return
    return window.sessionStorage.getItem(name)
}

/**
 * 删除sessionStorage
 */
export const removeSessionStore = name => {
    if (!name) return
    window.sessionStorage.removeItem(name)
}

// 引入RSA加密
const RSA = require('./rsa.js')
const RSAKEY = 'C2D84A72668932EBE5CC2BADB5DE288E59AD587775C1E45F33F6CC9DAB376C793AFF12050C0648D5C3016F685B9F4FA2460A59B6B07793808B4E68A883CA2830FD7895C66F68F64A829DB99DEDE978EC2E04711184A872C1F43956B1B72CFA803C1D677BAE386209368B3F3ED7A8CB06BEC64B0D0369EE62A49E6B417FC55959'
RSA.setMaxDigits(129) // 131 => n的十六进制位数/2+3
const RSASECRET = new RSA.RSAKeyPair('010001', '', RSAKEY) // 10001 => e的十六进制

function _encryptedString(value, opt) {
    let rsakey = void 0
    if (typeof opt === 'object' && opt.constructor === Object) {
        rsakey = new RSA.RSAKeyPair(opt.Exponent, '', opt.Modulus)
    } else {
        rsakey = RSASECRET
    }
    return RSA.encryptedString(rsakey, value).replace(/\s+/g, '')
}

export const encryptedString = (data, opt) => {
    if (typeof data === 'string') {
        return _encryptedString(data, opt)
    } else if (typeof data === 'object' && data.constructor === Object) {
        for (let key in data) {
            data[key] && (data[key] = _encryptedString(data[key], opt))
        }
    }
}

export const encryptByDESModeCBC = ({ data, desKey = "IJL9qaZ7", desIV = "t9TEPqji86aMVuUE"}) => {
    var keyHex = CryptoJS.enc.Utf8.parse(desKey);
    var ivHex = CryptoJS.enc.Utf8.parse(desIV);
    var encrypted = CryptoJS.DES.encrypt(data, keyHex, {
            iv:ivHex,
            mode: CryptoJS.mode.CBC,
            padding:CryptoJS.pad.Pkcs7
        }
    );
    var encryptedHexStr = CryptoJS.enc.Hex.parse(encrypted.ciphertext.toString());
    return Base64Stringify(encryptedHexStr);
}

function Base64Stringify(wordArray) {
    // Shortcuts
    var words = wordArray.words;
    var sigBytes = wordArray.sigBytes;
    var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='";

    // Clamp excess bits
    wordArray.clamp();

    // Convert
    var base64Chars = [];
    for (var i = 0; i < sigBytes; i += 3) {
        var byte1 = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
        var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
        var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

        var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

        for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
            base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
        }
    }

    // Add padding
    var paddingChar = map.charAt(64);
    if (paddingChar) {
        while (base64Chars.length % 4) {
            base64Chars.push(paddingChar);
        }
    }

    return base64Chars.join('');
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object'
}

export const isEmpty = (obj) => {
    if (!obj && obj !== 0 && obj !== '') {
        return true
    }
    if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
        return true
    }
    if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
        return true
    }
    return false
}

export const precisionFormat = (val, len) => {
    let res = new Object()
    let arr = ['', '十', '百', '千', '万', '十万', '百万', '千万', '亿']
    val = parseFloat(val) || 0
    len = len || 3
    let vs = val.toPrecision(len)
    let ve = vs.match(/(e\+)([^]*)$/i)
    if (ve) {
        res['val'] = vs.replace(ve[0], '')
        res['unit'] = arr[ve[2]]
    } else {
        res['val'] = vs
        res['unit'] = ''
    }
    return res
}

export const isFunction = (obj) => {
    return typeof obj === "function" && typeof obj.nodeType !== "number";
};

export const isAbsoluteURL = (url) => {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

export const isSID = (sid) => {
    if(!sid) return false
    return /^([A-z\d]+-)+([A-z\d]+)$/i.test(sid.split(/[&|?]/)[0]);
}

import CryptoJS from 'crypto-js'

const cajessFun = (endData, a, b) => {
    let key = CryptoJS.enc.Utf8.parse(a);
    let iv = CryptoJS.enc.Utf8.parse(b);
    let encryptResult = CryptoJS.AES.encrypt(endData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Base64.stringify(encryptResult.ciphertext);
}


const dcajessFun = (endData, a, b) => {
    let key = CryptoJS.enc.Utf8.parse(a);
    let iv = CryptoJS.enc.Utf8.parse(b);
    let baseResult = CryptoJS.enc.Base64.parse(endData);
    let ciphertext = CryptoJS.enc.Base64.stringify(baseResult);
    let decryptResult = CryptoJS.AES.decrypt(ciphertext, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    let resData = CryptoJS.enc.Utf8.stringify(decryptResult);
    return JSON.parse(resData)
}

function randomNum(n) {
    let rnd = "";
    for (let i = 0; i < n; i++) {
        rnd += Math.floor(Math.random() * 10);
    }
    return rnd;
}

const cajessParam = (param, a, b) => {
    let paramStr = isObject(param) ? JSON.stringify(param) : param
    let uts = Math.round(new Date().getTime() / 1000) + ""
    let uver = cajessFun(uts, a, b).substring(0, 16)
    let paramAfterEdit = cajessFun(paramStr, uts + "000000", uver)

    return JSON.stringify({
        Data: paramAfterEdit,
        UTS: uts,
        UVER: uver,
        UUID: (new Date()).getTime() + "" + randomNum(10)
    })
}

export const cajessInside = (endData) => {
    window._a = "6fb498553e3c462988c3b9573692bd5f";
    window._b = "98d71fe589499968";
    return cajessParam(endData, __a, __b)
}

export const cajessOutside = (endData) => {
    window._e = "02jjs3jse9c9333234fds3b93324f34544e";
    window._f = "8h23hf72g54fdj8232";
    if(isObject(endData)){
        Object.keys(endData).map((key) => {
            endData[key] = cajessParam(endData[key], __e, __f)
        })
    }
    // return cajessParam(endData, __e, __f)
}

const dcajessResult = (result, a, b) => {
    let decryptData = dcajessFun(result, a, b)
    let realData = dcajessFun(decryptData.Data, decryptData.UTS + "000000", decryptData.UVER)
    return realData
}

export const dcajessInside = (endData) => {
    window._a = "6fb498553e3c462988c3b9573692bd5f";
    window._b = "98d71fe589499968";
    return dcajessResult(endData, __a, __b)
}

export const dcajessOutside = (endData) => {
    window._e = "02jjs3jse9c9333234fds3b93324f34544e";
    window._f = "8h23hf72g54fdj8232";
    return dcajessResult(endData, __e, __f)
}

export const GetWxCode = (AppID, url, MPType) => {
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${AppID}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_base&state=${AppID}_${MPType}#wechat_redirect`
}

export const getMiniProgram = () => {

}

function combin(m) {
    let results = new Array()
    let result = new Array()
    !function (arr, depth) {
        depth = depth || 0
        for (let i = 0; i < arr[depth].length; i++) {
            result[depth] = arr[depth][i]
            if (depth != arr.length - 1) {
                arguments.callee(arr, depth + 1)
            } else {
                results.push(result.join(','))
            }
        }
    }(m, n = 0)
    console.log(results.join('||'))
}



// WEBPACK FOOTER //
// ./node_modules/teld-web-component/lib/method.js